<template>
  <div class="page">
    <header-el></header-el>

    <section class="page-hero">
      <div class="ui-container">
        <p class="crumb">首页 / 星选商城</p>
        <h1>星选商城</h1>
        <p class="lede">精选好物：科普地图与学习挂图，孩子的第一张启蒙地图</p>
      </div>
    </section>

    <div class="ui-container">
      <div class="float-panel">
        <!-- 分类 + 搜索 -->
        <div class="toolbar">
          <div class="seg">
            <button
              v-for="c in mallCategories"
              :key="c"
              class="seg__item"
              :class="{ 'is-active': current === c }"
              @click="current = c"
            >{{ c }}</button>
          </div>
          <div class="search">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
              <circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" />
            </svg>
            <input v-model.trim="keyword" type="text" placeholder="搜索好物…" />
          </div>
        </div>

        <!-- 商品栅格 -->
        <div class="grid">
          <div class="goods card" v-for="g in filtered" :key="g.name" @click="goMiniProgram(g)">
            <div class="goods__pic">
              <img :src="g.image" :alt="g.name" />
            </div>
            <span class="tag tag--solid goods__tag" v-if="g.tag">{{ g.tag }}</span>
            <h3>{{ g.name }}</h3>
            <p>{{ g.desc }}</p>
            <div class="goods__ft">
              <b>¥{{ g.price }}</b>
              <!-- <span class="goods__sales">{{ g.sales }} 人购买</span> -->
            </div>
          </div>
        </div>
        <p class="empty" v-if="filtered.length === 0">没有找到匹配的好物，换个关键词试试～</p>
      </div>
    </div>

    <div class="footer-gap"></div>
    <footer-el></footer-el>
  </div>
</template>

<script>
  import Header from "../components/header.vue";
  import Footer from "../components/footer.vue";
  import { mallCategories, mallItems } from "../data/site.js";
  import { launchMiniProgram } from "../utils/miniProgram.js";

  export default {
    components: {
      "header-el": Header,
      "footer-el": Footer
    },
    data() {
      return {
        mallCategories,
        mallItems,
        current: "全部",
        keyword: ""
      };
    },
    computed: {
      filtered() {
        var kw = this.keyword.toLowerCase();
        return this.mallItems.filter(function (g) {
          /* category 为分类名数组（可多个） */
          var okCat = this.current === "全部" || (g.category || []).indexOf(this.current) > -1;
          var okKw = !kw || g.name.toLowerCase().indexOf(kw) > -1 || String(g.desc || "").toLowerCase().indexOf(kw) > -1;
          return okCat && okKw;
        }, this);
      }
    },
    methods: {
      goMiniProgram(g) {
        launchMiniProgram(g);
      },
      goodsTone(g) {
        if (g.tag === "热卖") return "goods__pic--a";
        if (g.tag === "新品") return "goods__pic--b";
        return "goods__pic--c";
      }
    }
  };
</script>

<style scoped>
  .toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 26px;
  }

  /* 分段控件（官网分类 tab 同款） */
  .seg {
    display: inline-flex;
    background: #f5f6f8;
    border-radius: 999px;
    padding: 4px;
  }
  .seg__item {
    height: 34px;
    padding: 0 18px;
    border: none;
    border-radius: 999px;
    background: transparent;
    color: #4c515b;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.18s ease;
  }
  .seg__item.is-active {
    background: #e8382f;
    color: #fff;
    font-weight: 600;
  }

  .search {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 240px;
    height: 40px;
    padding: 0 16px;
    border-radius: 999px;
    background: #f5f6f8;
    color: #8a909b;
    transition: box-shadow 0.18s ease;
  }
  .search:focus-within {
    box-shadow: 0 0 0 2px rgba(232, 56, 47, 0.25);
    background: #fff;
  }
  .search input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: #23262d;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
  .goods { position: relative; padding: 16px; cursor: pointer; }
  .goods__tag { position: absolute; top: 24px; left: 24px; }

  .goods__pic {
    aspect-ratio: 4 / 3;
    border-radius: 12px;
    overflow: hidden;
    background: #f4f5f7;
    border: 1px solid #f2f3f5;
  }
  .goods__pic img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block; 
  }

  .goods h3 {
    margin-top: 12px;
    font-size: 14px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .goods p {
    margin-top: 4px;
    font-size: 12px;
    color: #8a909b;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 38px;
  }
  .goods__ft {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .goods__ft b { color: #e8382f; font-size: 17px; }
  .goods__sales { font-size: 12px; color: #8a909b; }

  .empty {
    padding: 48px 0;
    text-align: center;
    color: #8a909b;
    font-size: 14px;
  }

  @media (max-width: 1023px) {
    .grid { grid-template-columns: repeat(2, 1fr); }
  }

  @media (max-width: 767px) {
    .toolbar { flex-direction: column; align-items: stretch; gap: 12px; }
    .seg { overflow-x: auto; }
    .search { width: 100%; }
    .grid { grid-template-columns: 1fr; }
  }
</style>
